<template>
  <div class="lf">
    <img :src="src" style="width: 100%;height: 100%" alt="" @click="viewImg">
    <preview-modal ref="imageModal"></preview-modal>
  </div>
</template>

<script>
  import PreviewModal from '@views/general/modules/PreviewModal.vue'

  export default {
    name: 'PImage',
    components: { PreviewModal },
    props: {
      src: {
        type: String,
        default: ''
      }
    },
    data() {
      return {}
    },
    methods: {
      viewImg() {
        // 预览静态图片
        this.$refs.imageModal.show(this.src)
      }
    }
  }
</script>

<style lang="less" scoped>
.lf{
  float: left;
}
</style>
